import { Button, Stack, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

export type SignUpSwitchProps = {
  onSignUpSwitch: () => Promise<void>
}
export const SignUpSwitch: FC<SignUpSwitchProps> = ({ onSignUpSwitch }) => {
  const { t } = useTranslation('signUpArtist')
  const [open, openModal] = useState(false)
  return (
    <Stack sx={{ px: 5 }}>
      <Stack sx={{ pb: 5 }}>
        <Stack>
          <Typography sx={{ pt: 2, pb: 4 }}>
            {t('registerSwitchContent')}
          </Typography>
          <Stack sx={{ py: 3 }} alignItems="center">
            <Button
              type="submit"
              size="large"
              sx={{ width: 244 }}
              onClick={() => openModal(true)}
            >
              {t('toRegister')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
      <InformationModal
        open={open}
        onClose={() => openModal(false)}
        title={t('titleModalSwitch')}
        content={t('contentModalSwitch')}
        cancelText={t('closeModalSwitch')}
        buttons={
          <Button
            size="large"
            sx={{ minWidth: 212 }}
            onClick={async () => {
              await onSignUpSwitch()
              openModal(false)
            }}
          >
            ok
          </Button>
        }
      />
    </Stack>
  )
}
